export enum ContactDetailTab {
    Accounts = 'accounts',
    Leads = 'leads',
    Opportunities = 'opportunities',
    Offers = 'offers',
    Reservations = 'reservations',
}
